<template>
    <div class='visual-panorama'>
        <svg class="visual-panorama__svg-canvas" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" >
            <template v-for="icon in panorama">
                <svg
                    :x="[icon.left ? icon.left : 0]"
                    :y="[icon.top ? icon.top : 0]"
                    :key=icon.id
                    ref="anchor"
                ></svg>
            </template>
        </svg>
        <template v-for="icon in panorama">
            <button
                v-if="icon.uid"
                class="visual-panorama__item"
                :key=icon.id
                :style="{ top: icon.reposition.top, left: icon.reposition.left}"
                @click="openPopup(icon.uid)"
            >
                360&#176;
            </button>
        </template>

        <div v-if="isOpen" class="visual-panorama__popup">
            <div class="visual-panorama__planoplan" id="planoplan"></div>
            <div class="visual-panorama__close">
                <ButtonClose @click.native="isOpen = false"/>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Panorama.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonClose from 'components/button-close/ButtonClose';
import reposition from '../../helpers/reposition';


export default {
    components: {
        ButtonClose
    },
    data() {
        return {isOpen: false};
    },

    computed: {
        ...mapGetters({
            panorama: 'GET_PANORAMA'
        })
    },

    mounted() {
        this.position();

        window.addEventListener('resize', this.position);
    },

    methods: {
        ...mapActions(['changePosition', 'changeStateLoading']),

        /**
         * Метод позиционирует поинтеры согласно координатам svg-якорей.
         */
        position() {
            if (this.panorama && this.panorama.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'panorama',
                    coords
                });
            }
        },

        openPopup(uid) {
            this.changeStateLoading(true);
            this.isOpen = true;
            this.uid = uid;
        },

        initPlanoplan() {
            if (!this.isOpen) {
                return;
            }

            const widget = window.Planoplan.init({
                width : '100%',
                height: '100%',
                uid   : this.uid,
                el    : 'planoplan'
            });

            widget.on('load', () => {
                this.changeStateLoading(false);
            });
        }
    },

    watch: {
        panorama() {
            this.$nextTick(() => {
                this.position();
            });
        },

        isOpen() {
            this.$nextTick(() => {
                this.initPlanoplan();
            });
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
